import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IngredientModal } from '../IngredientModal';
import { Carousel } from '../../molecules';
import { useReporter } from '../../reporter';
import { RecipeCarouselIngredient } from './RecipeCarouselIngredient';
import {
  recipeFullIngredientsViewed,
  recipeIngredientCarouselTurn,
} from './events';
import { FullIngredientsButton } from './styles.js';

const breakPoints = [
  {
    width: 425,
    itemsToShow: 1,
  },
  {
    width: 600,
    itemsToShow: 2,
  },
  {
    width: 768,
    itemsToShow: 3,
  },
];

export const RecipeIngredientsList = ({ value, modal, ingredients, label }) => {
  const [shownModal, setShownModal] = useState(false);
  const reporter = useReporter();

  const onFullIngredientsClicked = () => {
    reporter.tag(recipeFullIngredientsViewed(label));
    setShownModal(true);
  };

  const recipeCarouselClicked = target => {
    reporter.tag(recipeIngredientCarouselTurn(label, target));
  };

  const fullIngredients = (
    <FullIngredientsButton onClick={onFullIngredientsClicked}>
      Full ingredients
    </FullIngredientsButton>
  );

  return (
    <>
      <Carousel
        breakPoints={breakPoints}
        dotPadding={8}
        buttonPosition="30"
        bottomElement={fullIngredients}
        overlappingArrows={false}
        onArrowClick={target => recipeCarouselClicked(target)}
        onDotClick={() => recipeCarouselClicked('dots')}
        resetIndex={value}
      >
        {ingredients.map(ingredient => (
          <RecipeCarouselIngredient key={ingredient.name} {...ingredient} />
        ))}
      </Carousel>
      <IngredientModal
        {...modal}
        shown={shownModal}
        onClickClose={() => setShownModal(false)}
      />
    </>
  );
};

RecipeIngredientsList.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  modal: PropTypes.object.isRequired,
  ingredients: PropTypes.array.isRequired,
};
